import React, { useEffect, useState } from "react";
import { ApiService } from "../../Components/Services/apiservices";
import constant from "../../Components/Services/constant";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import moment from "moment";

function Blog() {
  const { slug } = useParams(); // category slug
  const [pageData, setPageData] = useState({});
  const [blogData, setBlogData] = useState([]);
  const [blogImagePath, setBlogImagePath] = useState("");

  useEffect(() => {
    fetchPageMeta();
  }, []);

  useEffect(() => {
    if (slug) {
      fetchBlogsByCategory(slug);
    } else {
      fetchAllBlogs();
    }
  }, [slug]);

  const fetchPageMeta = () => {
    ApiService.postData("page-content", { slug: "blogs" }).then((res) => {
      if (res.status == "success") {
        setPageData(res.data);
      }
    });
  };

  const fetchAllBlogs = () => {
    ApiService.fetchData("blog-list").then((res) => {
      if (res.status == "success") {
        setBlogData(res.blogsData);
        setBlogImagePath(res.blog_image_path);
      }
    });
  };

  const fetchBlogsByCategory = (categorySlug) => {
    ApiService.postData("categorywiseblogs", { category_slug: categorySlug }).then((res) => {
      if (res.status == "success") {
        setBlogData(res.blogData);
        setBlogImagePath(res.blog_image_path);
      } else {
        setBlogData([]);
      }
    });
  };

  return (
    <>
      <Header state="inner-header" />
      <div className="subheader">
        <Container>
          <Row>
            <Col lg={12}>
              <h1>{pageData.page_name || "Blogs"}</h1>
              <Breadcrumb>
                <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                <Breadcrumb.Item active>{pageData.page_name || "Blogs"}</Breadcrumb.Item>
              </Breadcrumb>
            </Col>
          </Row>
        </Container>
      </div>

      <section className="sec-gap-medium">
        <Container>
          <Row>
            {blogData.length > 0 ? (
              blogData.map((value, index) => (
                <Col lg={4} key={index}>
                  <div className="listbog">
                    <div className="thumbnail">
                      <a href={`/blogs/${value.blog_slug}`}>
                        <img
                          src={
                            value.blog_image
                              ? blogImagePath + "/" + value.blog_image
                              : constant.DEFAULT_IMAGE
                          }
                          alt={value.blog_name}
                        />
                      </a>
                    </div>
                    <div className="content">
                      <div className="read-more-btn">
                        <a className="btn-icon-round" href={`/blogs/${value.blog_slug}`}>
                          <i className="d-icon-arrow-right"></i>
                        </a>
                      </div>
                      <h5 className="title">
                        <a href={`/blogs/${value.blog_slug}`}>{value.blog_name}</a>
                      </h5>
                      <ul className="blog-meta">
                        <li>
                          <a href={`/blogs/${value.blog_slug}`}>
                            <i className="fas fa-calendar-alt"></i>{" "}
                            {moment(value.created_at).format("MMM D, YYYY")}
                          </a>
                        </li>
                        <li>
                          <a href={`/blogs/${value.blog_slug}`}>
                            <i className="fas fa-user"></i> Admin
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Col>
              ))
            ) : (
              <Col>
                <p>No blogs found in this category.</p>
              </Col>
            )}
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
}

export default Blog;
